import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

export const vincularCotaAssinaturaService = async (
  assinaturaId: number,
  cotaUsuarioId: number
) => {
  const Token = validateToken();

  if (!Token) {
    throw new Error("Sessao expirada. Faca login novamente.");
  }

  const URL = `${Globais.DOMINIOBACK}/assinatura/${assinaturaId}`;

  const response = await axios.put(
    URL,
    {
      cotasUsuariosId: cotaUsuarioId,
    },
    {
      headers: { Authorization: Token.AuthStr },
    }
  );

  return response.data;
};
